module.exports = __webpack_public_path__ + "img/ic_happytable_management.d3c97e25.png";